import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { PersistenceService } from '../../../services/persistence.service';
import { PGUtilities } from '../../../utilities/pg-utilities';
import { EnvironmentService } from '../../../services/environment.service';

@Component({
    selector: 'app-pg-login-handler-otp',
    standalone: false,
    templateUrl: './pg-login-handler-otp.component.html',
    styleUrl: './pg-login-handler-otp.component.scss',
})
export class PgLoginHandlerOtpComponent implements OnInit {
    constructor(private authService:AuthService, private persistenceService:PersistenceService, private environmentService:EnvironmentService) {}

    @Input() noBack:boolean;

    @Output() afterLogin = new EventEmitter<void>()

    isLoading = false;
    loginError = false;

    disablePhone = false;

    ngOnInit(): void {
        let _savedObj = PGUtilities.tryParseJSON(this.persistenceService.getItem('PGLoginStatus')) 
        if(_savedObj) {
            this.loginOTPRecipient = _savedObj.user;
        }

        this.disablePhone = this.environmentService.environment.DisableSMS;
    }

    onLoginOTPKeyUp(event:KeyboardEvent) {
        if(event.key == 'Enter') {
            if(this.loginOTPSent) {
                this.doLoginOTP();
            }
            else {
                this.sendOTP();
            }
        }
    }

    loginOTPRecipient:string = null;
    loginOTPVia:'email'|'phone' = null;
    loginOTPVerify:string = null;

    loginOTPSendError:boolean = false;
    loginOTPSent:boolean = false;

    canSendOTP() {
        return this.loginOTPRecipient != null && this.loginOTPRecipient != '' && this.loginOTPVia != null;
    }

    sendOTP() {
        this.isLoading = true;
        this.loginError = false;
        this.loginOTPSendError = false;

        this.isLoading = false;
        this.loginOTPSent = true;

        this.authService.requestOTP(this.loginOTPRecipient, this.loginOTPVia).then(() => {
            this.isLoading = false;
            this.loginOTPSent = true;
        }, () => {
            this.isLoading = false;
            this.loginOTPSent = false;
            this.loginOTPSendError = true;
        })
    }

    resetOTP() {
        this.loginOTPSent = false;
        this.loginError = false;
        this.loginOTPSendError = false;
    }

    canLoginOTP() {
        return this.loginOTPVerify != null && this.loginOTPVerify != '';
    }

    doLoginOTP() {
        this.isLoading = true;
        this.loginError = false;

        this.authService.loginOTP(this.loginOTPRecipient, this.loginOTPVia, this.loginOTPVerify).then(() => {
            this.isLoading = false;
            this.persistenceService.setItem('PGLoginStatus', JSON.stringify({
                mode: 'otp',
                user: this.loginOTPRecipient
            }), 'technical');

            this.afterLogin.emit()
        }, () => {
            this.loginError = true;
            this.isLoading = false;
        })
    }
}
